/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Response after processing a progress update.
 */
export interface LabProgressResponse { 
    success: boolean;
    video_id: string;
    current_stage: string;
    message: string;
}

